import { useNavigate } from "react-router-dom";
import { useAppContext } from "context/app.context";
import { useCallback } from "react";
import { Logout } from "@mui/icons-material";
import { useAuth } from "hooks/useAuth";
import { CustomFab } from "components/buttons/CustomFab";
import { useUserType } from "hooks/useUserType";

export const LogoutButton = () => {
  const navigation = useNavigate();

  const { dispatch } = useAppContext();
  const { resetAuthData } = useAuth();

  const logout = useCallback(() => {
    resetAuthData();
    dispatch({ type: "LOGOUT" });
    navigation("/login");
  }, [dispatch, resetAuthData]);

  const { userTypeColour } = useUserType();

  return (
    <CustomFab 
      ariaLabel="logout" 
      onClick={logout}
      sx={{
        background: userTypeColour,
        color: "white",
        "&:hover": {
          color: userTypeColour,
        },
      }}
    >
      <>
        <Logout style={{ marginRight: "5px" }} /> LOGOUT
      </>
    </CustomFab>
  );
};
